import { StageDataField } from '@Components/Flows';
import { useTicketedEventTicket } from '../../../hooks/useTicketedEventTicket';
import { formatCurrency, formatDateWithTime } from '@Utils/utils';

const discountTypeObj = {
  PERCENTAGE: '%',
  FLATAMOUNT: 'off',
  PRICEOVERRIDE: 'Price Override',
};

export function StageContentTicketPurchase({ stage }) {
  const purchaseId = stage?.result?.responseDataBindings?.[0];

  const { data: ticketRes } = useTicketedEventTicket({
    searchParams: {
      'filter[purchaseId]': purchaseId,
      'include': 'ticketType,event.venue,purchase',
    },
    enabled: !!purchaseId,
  });

  const tickets = ticketRes?.data;

  const groupedTickets = tickets?.reduce((acc, ticket) => {
    const typeName = ticket.ticketType?.name;

    if (!acc[typeName]) {
      acc[typeName] = [];
    }

    acc[typeName].push(ticket);
    return acc;
  }, {});

  const ticket = ticketRes?.data?.length > 0 ? ticketRes?.data?.[0] : null;

  const ticketPurchaseProductDescription =
    ticket?.purchase?.productDescription ?? 'N/A';
  const ticketPurchaseCreatedAt =
    formatDateWithTime(ticket?.purchase?.createdAt) ?? 'N/A';
  const ticketPurchaseConfirmationNumber =
    ticket?.purchase?.confirmationNumber ?? 'N/A';
  const ticketPurchaseOriginalPrice =
    formatCurrency(ticket?.purchase?.originalPrice) ?? 'N/A';
  const ticketPurchaseDiscountAmount =
    formatCurrency(ticket?.purchase?.discountAmount) ?? null;
  const ticketPurchaseDiscountType = ticket?.purchase?.discountType ?? null;
  const ticketPurchasePrice = formatCurrency(ticket?.purchase?.price) ?? 'N/A';

  const discount =
    ticketPurchaseDiscountAmount && ticketPurchaseDiscountType
      ? `${ticketPurchaseDiscountAmount} ${discountTypeObj[ticketPurchaseDiscountType]}`
      : 'N/A';

  const ticketEventName = ticket?.event?.name ?? 'N/A';
  const ticketEventDescription = ticket?.event?.description ?? 'N/A';
  const ticketEventStart =
    formatDateWithTime(ticket?.event?.startDateTime) ?? 'N/A';
  const ticketEventEnd =
    formatDateWithTime(ticket?.event?.endDateTime) ?? 'N/A';
  const ticketEventCapacity = ticket?.event?.capacity.toString() ?? 'N/A';
  const ticketEventVisibility = ticket?.event?.visibility ?? 'N/A';
  const ticketEventStatus = ticket?.event?.status ?? 'N/A';

  const ticketEventVenueName = ticket?.event?.venue?.name ?? 'N/A';
  const ticketEventVenueDescription =
    ticket?.event?.venue?.description ?? 'N/A';

  return (
    <div className="flex flex-col gap-3">
      {groupedTickets &&
        Object.keys(groupedTickets).map((key, i) => {
          const tempTicket = groupedTickets[key][0];
          const quantity = groupedTickets[key].length;

          const ticketTypeName = tempTicket?.ticketType?.name;
          const ticketTypeDescription = tempTicket?.ticketType?.description;
          const ticketTypePrice = tempTicket?.ticketType?.price;

          return (
            <div key={`${key}-${i}`}>
              <div className="break-word w-1/2">
                <StageDataField label={'Ticket Type'} value={ticketTypeName} />
              </div>

              <div className="break-word w-1/2">
                <StageDataField
                  label={'Ticket Description'}
                  value={ticketTypeDescription}
                />
              </div>

              <div className="break-word w-1/2">
                <StageDataField
                  label={'Ticket Price'}
                  value={ticketTypePrice}
                />
              </div>

              <div className="break-word w-1/2">
                <StageDataField label={'Quantity'} value={quantity} />
              </div>

              {/* horizontal line */}
              <div className="my-4 h-px w-full bg-zinc-200" />
            </div>
          );
        })}

      <div className="break-word w-1/2">
        <StageDataField
          label={'Purchase Description'}
          value={ticketPurchaseProductDescription}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Purchase Date'}
          value={ticketPurchaseCreatedAt}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Confirmation Number'}
          value={ticketPurchaseConfirmationNumber}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Original Price'}
          value={ticketPurchaseOriginalPrice}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Discount'} value={discount} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Price Paid'} value={ticketPurchasePrice} />
      </div>

      {/* horizontal line */}
      <div className="my-4 h-px w-full bg-zinc-200" />

      <div className="break-word w-1/2">
        <StageDataField label={'Venue Name'} value={ticketEventVenueName} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Venue Description'}
          value={ticketEventVenueDescription}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Event Name'} value={ticketEventName} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Event Description'}
          value={ticketEventDescription}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Event Start Date'} value={ticketEventStart} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Event End Date'} value={ticketEventEnd} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Event Capacity'} value={ticketEventCapacity} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Event Visibility'}
          value={ticketEventVisibility}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Event Status'} value={ticketEventStatus} />
      </div>
    </div>
  );
}
